<script setup lang="ts">
defineProps<{
    v: unknown;
}>();
</script>

<template>
    <pre>{{ v === undefined ? 'undefined' : JSON.stringify(v, null, 4) }}</pre>
</template>
